export default {
  config: {},
  ticketPreviewData: null,
  ticketPreviewActive: false,
  ticketIcons: {
    positive: 'n-i-check-a',
    neutral: 'n-i-clock',
    negative: 'n-i-close',
  },
  ticketAction: '',
  eventInProgress: true,
  ticketActionSuccessful: true,
  autoPayout: false,
  payoutConfirmation: {},
  cancelConfirmation: true, // print cancel confirmation
  payoutConfirmationReprint: true,
  deviceId: '',
  printedTicketsByTicketCheck: [],
  ticketsPrintedByTicketUpdate: [],
  ticketChecksInProgress: [],
  ticketsScheduledToBeChecked: [],
  bettingDisabled: false,
  //* COMMON STATE
  currentActiveGame: '',
  activeProducts: [],
  supportedActiveProducts: [
    'luckysix',
    'greyhoundraces',
    'crashcash',
    'virtualgreyhoundraces',
    'virtualhorseraces',
    'virtualmotorcyclespeedway',
    'keno',
    'luckyx',
  ],
  sevenProductsMapper: {
    greyhoundraces: 'GreyhoundRaces',
    luckysix: 'LuckySix',
    crashcash: 'CrashCash',
    virtualgreyhoundraces: 'VirtualGreyhoundRaces',
    virtualhorseraces: 'VirtualHorseRaces',
    virtualmotorcyclespeedway: 'VirtualMotorcycleSpeedway',
    keno: 'Keno',
    luckyx: 'LuckyX',
  },
  activeBusAdapters: [],
  globalEvents: [
    'UI.Show',
    'Slave.Unmute',
    'Tickets.GetActions',
    'Tickets.ReCheck',
    'Tickets.Checked',
    'Widget.Event',
    'Master.Event',
    'Tickets.PayingSentSuccess',
    'Tickets.PayoutSentSuccess',
    'Tickets.CancelSentSuccess',
    'Tickets.PayingFailed',
    'Tickets.PayoutFailed',
    'Tickets.CancelFailed',
    'Tickets.ReBet',
    'Tickets.PrintCopy',
    'Betslip.Blocked',
    'Betslip.Unblocked',
  ],
  isAppLoaded: false,
  staticConfig: {},
  gamesState: {},
  editBetModeActive: false,
  betEditBet: {},
  betEditInputId: null,
  operatorPermissions: {},
  socketReInitInProgress: false,
  afterloadActiveGame: null, // Used for showing current game when others are still loading
  shopMode: 'integration',
  allNotifications: [],
  tenantId: null,
  lastTickets: [],
  ticketPinEnabled: false,
  ticketPinModalActive: false,
  ticketWaitingForPayout: {},
  ticketPinAction: '',
  thirdPartyInfo: {},
  regulatoryInputModalActive: false,
  regulatoryInputModalEnabled: false,
  ticketWaitingAction: '',
};
